import PL_utils from './pl-utils.js';

const app = {};

app.isi = app.isi || {};

app.isi.visibility = (function () {
  const pageIsi = document.getElementById('main-isi');
  const stickyIsi = document.getElementById('sticky-isi');
  const backToTop = document.querySelector('.back-to-top');

  if (typeof PL_utils === 'undefined') {
    console.log('isi-seemore.js required pl-utils.js as a dependency.');
    return;
  }

  const PL = PL_utils;

  let headerOffset = {};

  const currentScrollPos = function () {
    const doc = document.documentElement;
    const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    return top;
  };

  const isiScrollPos = function () {
    const rect = pageIsi.getBoundingClientRect();
    return rect.top + window.pageYOffset;
  };

  const currentOffsetVal = function () {
    const ww = window.innerWidth;
    let viewport = 'desktop';
    const tabletBreakpoint = 769;
    const mobileBreakpoint = 481;
    if (ww < tabletBreakpoint) { viewport = 'tablet'; }
    if (ww < mobileBreakpoint) { viewport = 'mobile'; }

    const selectedOffset = (typeof (headerOffset) != 'undefined' && headerOffset.offsets[viewport]) || 0;
    return selectedOffset;
  };

  const pageIsiVisible = function () {
    if (currentScrollPos() + window.innerHeight - currentOffsetVal() > isiScrollPos()) {
      return true;
    }
    return false;
  };

  const setVisibility = function () {
    const zoomValue = Math.round(window.devicePixelRatio * 100);
    const deviceWidth = window.innerWidth;
    const isiAtTop = pageIsi.getBoundingClientRect().top <= 0;
    
    if (pageIsiVisible() || (zoomValue >= 300 && deviceWidth > 450)) {
      PL.removeClass('fixed', stickyIsi);
      if (isiAtTop) {
        PL.removeClass('back-to-top-hide', backToTop);
      } else {
        PL.addClass('back-to-top-hide', backToTop);
      }
    } else {
      PL.addClass('fixed', stickyIsi);
      PL.addClass('back-to-top-hide', backToTop);
    }
  };

  const bindEvents = function () {
    window.addEventListener('scroll', function () {
      setVisibility();
    });

    window.addEventListener('resize', function () {
      setVisibility();
    });
  };

  const init = function (offset) {
    headerOffset = offset ? offset : headerOffset;
    setVisibility();
    bindEvents();
  };

  return {
    init: init
  };
})();

export default () => {
  if (window.location.href.indexOf('ed=1') > -1){
    return;
  }
  app.isi.visibility.init({
    'offsets': {
      desktop: 88,
      tablet: 88,
      mobile: 88
    }
  });
};